import React, {useState} from "react";
import {
  ModalContainer,
  ModalText,
} from "../../common/components/modules/modal/modalComponents";
import {PrimaryLoadingButton} from "../../common/components/elements/button/PrimaryButton";
import {FormContainer, FormText} from "../../common/components/collections/form/forms";
import styled, {createGlobalStyle} from "styled-components";
import useAgeGate from "../hooks/useAgeGate";
import Error, {ErrorsList} from "../../common/components/elements/Error";
import Modal from "../../common/components/modules/modal/Modal";
import useFeatureToggles from "../../common/hooks/useFeatureToggles";
import useSite from "../../sites/hooks/useSite";
import Title from "src/core/common/components/modules/Title";

function AgeGate() {
  const [showError, setShowError] = useState(false);
  const [hasAllowedAge, setHasAllowedAge] = useAgeGate();
  const toggles = useFeatureToggles();
  const site = useSite();
  const siteOptions = site.getOptions();
  const minimumAge = siteOptions.getMinimumAge();
  const allowRecreationalCustomers = siteOptions.allowRecreationalCustomers();
  const allowMedicalCustomers = siteOptions.allowMedicalCustomers();
  const minimumAgeMedical = siteOptions.minimumAge() || 18;

  function confirmAllowedAge() {
    setHasAllowedAge(true);
  }

  if (hasAllowedAge) return null;

  return (
    <Modal isOpen={true} allowedToClose={() => false}>
      <CustomModalContainer>
        <GlobalStyles />
        <Title data-cy="ageGateHeader">Are you {minimumAge} or older?</Title>
        <FormContainer>
          {showError && (
            <ErrorsList>
              <li>
                <Error>You must be {minimumAge} or older.</Error>
              </li>
            </ErrorsList>
          )}
          {toggles.allowDocumentsOnPersonalInformation() &&
            allowRecreationalCustomers &&
            allowMedicalCustomers && (
              <CenterModalText>
                *Or {minimumAgeMedical}+ with a valid medical recommendation.
              </CenterModalText>
            )}
          <PrimaryLoadingButton
            dataCy="ageGateConfirmButton"
            onClick={confirmAllowedAge}
            label="I'm old enough"
          />
          <Footer alignment={"center"}>
            <span onClick={() => setShowError(true)}>I’m too young</span>
          </Footer>
        </FormContainer>
      </CustomModalContainer>
    </Modal>
  );
}

const GlobalStyles = createGlobalStyle`
  #quantity-picker-container {
    display: none;
  }
`;

const CustomModalContainer = styled(ModalContainer)`
  margin-top: 30px;
`;

const CenterModalText = styled(ModalText)`
  text-align: center;
  margin-bottom: 50px;
`;

const Footer = styled(FormText)`
  margin-top: ${({theme}) => theme.v2.spacing(6)};
`;

export default AgeGate;
